import { render, staticRenderFns } from "./callManage.vue?vue&type=template&id=5f3bb58b&scoped=true"
import script from "./callManage.vue?vue&type=script&lang=ts"
export * from "./callManage.vue?vue&type=script&lang=ts"
import style0 from "./callManage.vue?vue&type=style&index=0&id=5f3bb58b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3bb58b",
  null
  
)

export default component.exports